import { css } from '@emotion/react'

type ResponsiveGridProps = {
  children: React.ReactNode
  maxColumns?: number
  minColumnSize?: number
  columnGap?: number
  rowGap?: number
}

const ResponsiveGrid = ({ children, columnGap = 24, maxColumns = 3, minColumnSize = 400, rowGap = 24 }: ResponsiveGridProps) => {
  const columnSizeCalc = `calc((100% - ${(maxColumns - 1) * columnGap}px) / ${maxColumns})`
  const columnMinSizeCalc = `min(100%, max(${minColumnSize}px, ${columnSizeCalc}))`

  const inlineStyle = {
    columnGap: columnGap,
    gridTemplateColumns: `repeat(auto-fit, minmax(${columnMinSizeCalc}, 1fr))`,
    rowGap: rowGap,
  }

  return <div css={[styles.grid, inlineStyle]}>{children}</div>
}

const styles = {
  grid: css({
    display: 'grid',
    width: '100%',
  }),
}

export default ResponsiveGrid
